import React, { ReactNode, FC, useContext, HTMLAttributes } from 'react';
import { TypeStatics } from 'ia-react-core/~/interfaces/TypeStatic';

import TableHeadContext from '../_TableHeadContext';
import { StyledRow } from './TableRow.styles';
import TableContext from '../_TableContext/TableContext';

export interface TableRowProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  borderColor?: string;
  background?: string;
  hoverBackground?: string;
  alignItems?: string;
  height?: number;
}

export interface TableRowStatics extends TypeStatics {
  Styled: typeof StyledRow;
}

/**
 * @mode developer
 */
const TableRow: FC<TableRowProps> & TableRowStatics = (props) => {
  const { displayMode } = useContext(TableContext);
  const { isHead } = useContext(TableHeadContext);

  return (
    <StyledRow
      role="row"
      displayMode={displayMode}
      {...props}
      isHead={isHead}
    />
  );
};

TableRow.type = Symbol('Table.Row');
TableRow.Styled = StyledRow;

export default TableRow;
